import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var StumbleuponWithCircle = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 20 20"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 .4C4.698.4.4 4.698.4 10s4.298 9.6 9.6 9.6 9.6-4.298 9.6-9.6S15.302.4 10 .4zm0 7.385a.53.53 0 00-.531.529v3.168a2.262 2.262 0 01-4.522 0v-1.326h1.729v1.326a.53.53 0 00.531.529.53.53 0 00.531-.529V8.314a2.262 2.262 0 014.523.001v.603l-1.04.334-.69-.334v-.604A.53.53 0 0010 7.785zm5.053 3.697a2.262 2.262 0 01-4.523 0v-1.354l.69.334 1.04-.334v1.354a.53.53 0 001.061 0v-1.326h1.731v1.326z"
  }));
});
StumbleuponWithCircle.displayName = 'StumbleuponWithCircle';
export var StumbleuponWithCircleDimensions = {
  height: 20,
  width: 20
};